export default "__VITE_ASSET__lS4xDyxR__"